import { Injectable } from '@angular/core';
import { ConfirmDialogModel, ConfirmdialogComponent } from '@app/components/shared/dialog/confirmdialog/confirmdialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from '@app/services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  result = '';

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private authService: AuthService) { }

  confirmDialog(msg: string, route: string, logout: boolean): void {
    const dialogData = new ConfirmDialogModel('', msg, 'info', logout);
    const dialogRef = this.dialog.open(ConfirmdialogComponent, {
      minWidth: '400px',
      minHeight: '200px',
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      this.result = dialogResult;
      if (this.result) {
        this.router.navigate([route]);
        if (dialogData.logout) {
          this.authService.logout();
        }
      }
    });
  }
}
